module.exports = __webpack_public_path__ + "img/icon_material_ystg.597f7fb2.webp";